module.exports = __webpack_public_path__ + "img/lithuania.18d6bab3.svg";